<div class="list-group">
  <div class="list-group-item d-flex pt-2 pb-1" *ngFor="let template of templates">
    <div class="col-9 mr-auto">
      <h5 class="mb-0">{{template.name}}</h5>
    </div>
    <div *ngIf="crudMode" class="col-3 ml-auto">
        <button class="btn btn-link float-right pt-0 pb-0 pl-2"
          type="button" (click)="confirmDelete(template)">
            <fa-icon class="fa" [icon]="trashAlt" data-toggle="tooltip" title="Excluir receita"></fa-icon>
        </button>
        <button class="btn btn-link float-right pt-0 pb-0 pr-1"
          type="button" routerLink="{{template.id}}">
            <fa-icon class="fa" [icon]="pencilAlt" data-toggle="tooltip" title="Editar receita"></fa-icon>
        </button>
    </div>
    <div *ngIf="!crudMode" class="col-3 ml-auto">
        <button class="btn btn-link float-right pt-0 pb-0 pr-1"
          type="button" (click)="select(template)">
            <fa-icon class="fa" [icon]="plusCircle" data-toggle="tooltip" title="Selecionar receita"></fa-icon>
        </button>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" #createNewModal tabindex="-1" role="dialog" aria-labelledby="createNewModal" aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Excluir?</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        Tem certeza que deseja excluir a receita: {{templateToDelete.name}}?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal" >Cancelar</button>
        <button type="button" class="btn btn-danger" data-dismiss="modal" (click)="deletePrescriptionTemplate()">Excluir</button>
      </div>
    </div>
  </div>
</div>
